app.controller('SupportBugReportController', ['$scope', '$rootScope', function ($scope, $rootScope) {

    $scope.bug_report = {};
    $scope.form_disabled = false;

    $scope.reportBug = function (validateFormCallback) {

        $scope.form_disabled = true;
        $rootScope.service.support.reportBug($scope.bug_report, function (success, data, messages) {
            $scope.form_disabled = false;
            validateFormCallback(success, messages)
        });
    }

}]);